// Зимний сезон новогоднего интерфейса (снег, ёлка на экране загрузки, зимний favicon):
// с 1 декабря по 14 января включительно.
export function isWinterSeason(date = new Date()) {
    const day = date.getDate();
    const month = date.getMonth();

    return month === 11 || (month === 0 && day <= 14);
}

export default isWinterSeason;
